<script setup lang="ts">
    import { computed, onMounted, inject, ref } from "vue";
    import { Link, router } from "@inertiajs/vue3";
    import { usePage } from "@inertiajs/vue3";
    import { storeToRefs } from "pinia";
    import { useSettingsStore } from "@/store/settings";
    import { useCartDetails } from "@/helpers/composables/useCartDetails";
    import { onClickOutside } from "@vueuse/core";
    import CloseIcon from "@icons/closeIcon.svg";
    import CarretsBlack from "@icons/carrets-black.svg";
    import FreeShipping from "@icons/free-shipping.svg";
    // import { route } from "ziggy-js";
    const settingsStore = useSettingsStore();
    const dialogRef = inject('dialogRef');
    const route = inject('route');

    let {
        currentList,
        freeShippingMessage,
        freeShippingProgressPercentage,
        is_dealer,
        canPlaceOrders,
        canSeePricing
    } = storeToRefs(settingsStore);

    const last_added_item = computed(() => {
        return usePage().props.last_added_item;
    });

    let { isPropertyVisible, currencySymbol, subTotal, listItem} = useCartDetails(last_added_item, currentList, 'preview');

    const lastAddedItem = computed(() => {
        return listItem.value;
    });

    const closeCartPreview = () => {
        dialogRef?.value?.close();
    }

    let isDealer = computed(() => {
        return is_dealer.value;
    });

    const shippingInfoStyle = computed(() =>  {
        return {
            '--shipping-progress': `${freeShippingProgressPercentage.value}%`
        };
    });

    const checkoutRoute = computed(() => {
        return isDealer.value ? route("checkout.express") : route("shop.show");
    });


    const cartShowRoute = computed(() => {
        return route("cart.show");
    });

    let cartRoute = computed(()=>route("cart.show"));
    

    onMounted(() => {
        let removeEventListener = router.on("navigate", () => {
            closeCartPreview();
        });

        //before the window closes, remove the event listener
        window.addEventListener("beforeunload", () => {
            removeEventListener();
        });
    });


    let cartModal = ref(null);

    onClickOutside(cartModal, closeCartPreview);
</script>

<template>
        <main>
    		<div class="modal added-to-cart-modal added-to-cart-b2b" ref="cartModal">
			<div class="modal__header">
				<h2 class="headline-s">Added to cart</h2>
				<CloseIcon  @click="closeCartPreview" class="modal__header--close" alt="Close Compare Drawer" aria-label="Close" />
			</div>
			<div class="modal__body">
				<div class="cart-item">
					<a href="#" class="cart-item__image" aria-label="Tactical BDU Pants">
						<img  :src="lastAddedItem.item.item_picture" alt="Tactical BDU Pants">
					</a>
					<div class="cart-item__information">
						<h5 class="title-s"> {{ lastAddedItem.item.item_name }}</h5>
						<p class="paragraph-details" v-if="isPropertyVisible('item_no')">#{{ lastAddedItem.item_no }}</p>
						<p class="paragraph-details">
                            {{lastAddedItem.item.formattedVariants}}
                        </p>
						<p class="paragraph-details last-item-qty" v-if="isPropertyVisible('quantity')">Qty: {{ lastAddedItem.quantity }}</p>
						<div class="cart-item__information-price">
							<span class="b2b-price" v-if="isPropertyVisible('unit_price') && canSeePricing"> {{ lastAddedItem.formattedPrice }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="add-to-cart-footer">
                <div v-if="isPropertyVisible('free_shipping_msg')" class="shipping-info" :style="shippingInfoStyle">
					<FreeShipping class="modal__footer--shipping-icon" alt="Free shipping" />
					<p class="title-xs">{{ freeShippingMessage }}</p>
				</div>
				<div class="subtotal">
					<p class="title-s">Subtotal</p>
					<p class="paragraph-default">
                        <template v-if="isPropertyVisible('total_styles')">{{ currentList.total_styles }} Styles</template>
                        <span v-if="isPropertyVisible('total_styles')" class="subtotal-divider">|</span>
                        <template v-if="isPropertyVisible('total_skus')">{{ currentList.total_skus }} SKUs</template>
                        <span v-if="isPropertyVisible('total_skus')" class="subtotal-divider">|</span>
                        <template v-if="isPropertyVisible('total_quantity')">{{ currentList.total_quantity }} Qty</template>
                        <span class="subtotal-divider">|</span>
                        <template v-if="isPropertyVisible('subtotal') && canSeePricing">{{currencySymbol}}{{ subTotal }}</template>
                    </p>
				</div>
				<div class="add-to-cart-cta">
                    <Link
                        as="button"
                        :href="cartShowRoute"
                        :onBefore="() => closeCartPreview()"
                        class="secondary small" aria-label="View Cart"
                    >
                        View Cart
                        <div aria-label="hidden" class="icon">
                            <CarretsBlack alt="arrow right"/>
                        </div>
                    </Link>
                    <Link
                        v-if="canPlaceOrders"
                        as="button"
                        :href="checkoutRoute"
                        :onBefore="() => closeCartPreview()"
                        class="primary small" aria-label="Proceed to Checkout"
                    >
                        Checkout
                        <div aria-label="hidden" class="icon">
                            <CarretsBlack alt="carrets right"/>
                        </div>
                    </Link>
				</div>
			</div>
		</div>
        <div class="modal-overlay active"></div>
        </main>
</template>

<style scoped> 
    .modal.added-to-cart-modal .add-to-cart-footer .shipping-info:after {
        width: var(--shipping-progress);
    }
</style>


